import { useQuery } from "@tanstack/react-query";
import { CHECK_PROFESSIONAL_KEY } from "@/shared/constants";
import { httpClient } from "@/config";
import { API_CHECK_PROFESSIONAL_DATA } from "@/common/consts/apiUrls";

export interface ProfessionalData {
  readonly id: number;
  readonly login_uuid: string;
  readonly name: string;
  readonly surname: string;
  readonly id_profession: number | null;
  readonly id_registration_type: number | null;
  readonly registration_number: string | null;
  readonly document_number: string | null; // Este es el CUIT
  readonly health_professional: boolean;
  readonly id_fhir: string | null;
  readonly signature_url: string | null;
}

interface RegisteredProfessionalData {
  professional_data_registered: true;
  professional_data: ProfessionalData;
}

interface UnregisteredProfessionalData {
  professional_data_registered: false;
  professional_data: unknown;
}

export interface ProfessionalDataResponse {
  message: string;
  data: RegisteredProfessionalData | UnregisteredProfessionalData;
}

const fetchProfessionalData = async (): Promise<ProfessionalDataResponse> => {
  return (await httpClient.getBackoffice(
    API_CHECK_PROFESSIONAL_DATA,
  )) as ProfessionalDataResponse;
};

export default function useCheckProfessionalQuery() {
  return useQuery({
    queryKey: [CHECK_PROFESSIONAL_KEY],
    queryFn: fetchProfessionalData,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    staleTime: Infinity,
  });
}
